import UserLoginsHistory from './UserLoginsHistory';

export default UserLoginsHistory;
